/** Типы виджетов и подписи для UI (icon — класс иконки Tabler) */
export const WIDGET_TYPES = [
  { id: 'counter', label: 'Счётчик', icon: 'ti ti-123' },
  { id: 'list', label: 'Список карточек', icon: 'ti ti-list' },
  { id: 'bar', label: 'Гистограмма (бар)', icon: 'ti ti-chart-histogram' },
  { id: 'donut', label: 'Донат (распределение)', icon: 'ti ti-chart-donut' },
]

/** Иконки разделов (ДО) для карточек в конструкторе */
export const ENTITY_ICONS = {
  requests: 'ti ti-file-text',
  contractors: 'ti ti-building-store',
  territories: 'ti ti-map-pin',
  modes: 'ti ti-toggle-right',
  access_objects: 'ti ti-lock',
  object_groups: 'ti ti-folder',
  autopark: 'ti ti-car',
  granted_accesses: 'ti ti-key',
}

/** Размеры по умолчанию при добавлении виджета по типу */
export const DEFAULT_WIDGET_SIZE_BY_TYPE = {
  counter: { w: 3, h: 2 },
  list: { w: 12, h: 4 },
  bar: { w: 6, h: 5 },
  donut: { w: 6, h: 5 },
}

/** Варианты размера виджета в конструкторе (только для нового виджета) */
export const WIDGET_SIZE_PRESETS = [
  { id: 'default', label: 'По умолчанию', size: null },
  { id: 's', label: 'Маленький (3×2)', size: { w: 3, h: 2 } },
  { id: 'm', label: 'Средний (6×4)', size: { w: 6, h: 4 } },
  { id: 'l', label: 'Большой (12×5)', size: { w: 12, h: 5 } },
]

export const DEFAULT_CONFIG = {
  type: 'counter',
  entity: 'requests',
  filters: {},
  title: '',
  limit: 10,
  groupBy: 'date',
  period: 'week',
}
